import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import { AuthProvider } from "@/lib/auth";
import { SiteContentProvider } from "@/lib/siteContent";
import Layout from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Experiences from "@/pages/Experiences";
import Gallery from "@/pages/Gallery";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Portal from "@/pages/Portal";
import CRM from "@/pages/CRM";
import Admin from "@/pages/Admin";
import TeamDashboard from "@/pages/TeamDashboard";

function AppRouter() {
  const location = useLocation();
  // Synchronous OAuth callback check — must run during render, not useEffect
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  // Admin panel is standalone (no shared layout, own password gate)
  if (location.pathname.startsWith("/admin")) {
    return <Admin />;
  }
  // Team dashboard is standalone (own auth)
  if (location.pathname.startsWith("/team")) {
    return <TeamDashboard />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/experiences" element={<Experiences />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/journal/:slug" element={<JournalPost />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book" element={<Booking />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/portal"
          element={
            <ProtectedRoute>
              <Portal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/crm"
          element={
            <ProtectedRoute roles={["admin", "partnerships", "marketing"]}>
              <CRM />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <SiteContentProvider>
            <AuthProvider>
              <AppRouter />
            </AuthProvider>
          </SiteContentProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
